import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { PageTransition } from './PageTransition';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => (
  <>
    <Navbar />
    <main>
      <PageTransition>{children}</PageTransition>
    </main>
    <Footer />
  </>
);
